import { render } from 'preact';
import { App } from './ui/App';
import './styles.css';

render(<App />, document.getElementById('app')!);

// Test hook: exposes state for automated end-to-end tests (read-only use).
if (import.meta.env.MODE !== 'production' || new URLSearchParams(location.search).has('testhooks')) {
  import('./app/testHooks').then((m) => m.install());
}
